import axios from 'axios';
import { ACTIONS, URLS, STORAGE } from '../../_config';
import { store } from '../../store';

const axiosApiInstance = axios.create();

axiosApiInstance.interceptors.response.use((response: any) => {
	return response
}, async function (error: any) {
	return Promise.reject(error);
});

export function getUserData() {
	let userData = localStorage.getItem(STORAGE)
	if (userData) {
		return JSON.parse(userData).data
	} else {
		return null
	}
}
function checkSessionExpiration() {
	const token = localStorage.getItem('accessToken');
	const loginTimestamp = localStorage.getItem('loginTimestamp');

	if (!token || !loginTimestamp) {
		return;
	}

	const sessionAge = Date.now() - parseInt(loginTimestamp);

	const expirationLimit = 24 * 60 * 60 * 1000; // 24 hours

	if (sessionAge > expirationLimit) {
		localStorage.removeItem('accessToken');
		localStorage.removeItem('loginTimestamp');
		window.location.href = '/login';
	}
};



export function getToken() {
	let token_str = localStorage.getItem(STORAGE)
	if (token_str) {
		return JSON.parse(token_str).access_token // accessToken
	} else {
		return null
	}
}


const apiCatch = (error: any) => {
	console.log('error', error, window.location.pathname);
	if (error.response) {
		const { status } = error.response;

		switch (status) {
			case 401:
				handleUnauthorizedError();
				break;

			case 400:
			case 404:
			case 422:
			case 500:
			case 502:
				handleClientOrServerError();
				break;

			default:
				handleUnauthorizedError();
				break;
		}
	}

	function handleUnauthorizedError() {
		localStorage.removeItem(STORAGE);
		localStorage.clear();
		store.dispatch({
			type: ACTIONS.USER.LOGOUT,
			payload: {},
		});
		window.location.href = process.env.PUBLIC_URL + URLS.USER.LOGIN;
	}

	function handleClientOrServerError() {
		// Handle specific client or server errors here if needed
		// Example: window.location.href = window.location.pathname;
	}
}


export const responseHandler = (resp: any) => {
	if (resp.status >= 200 && resp.status < 300 && resp.data) {
		if (resp.data.data.exceptions?.length) {
			return { status: false, data: resp.data.data.exceptions.join(',') }
		} else {
			return { status: true, data: resp.data }
		}
	} else {
		return { status: false, data: resp.data }
	}
}

export class CallApi {
	static GET(url: any, params: any, isAuth: boolean = false, isAdaptive: any = (e: any) => { }) {
		return new Promise(async (resolve, reject) => {
			const urls = new URL(window?.location?.href);
			let headers: any = {
				'Content-Type': 'application/json',
				AppHost: urls.hostname
			}

			if (isAuth || isAdaptive) {
				let token = getToken()

				if (token) {
					headers.Authorization = `Bearer ${token}`
				}
			}

			return axiosApiInstance({ method: 'GET', url, headers, params, }).then((success: any) => {
				return resolve(success)
			}).catch((error: any) => {
				apiCatch(error)
				console.log('error', error)
				return reject(error.response)
			})
		})
	}

	static POST(url: any, params: any, isAuth: boolean = false, isAdaptive: any = (e: any) => { }) {
		return new Promise((resolve, reject) => {
			const urls = new URL(window?.location?.href)
			let headers: any = {}
			const token = getToken()
			if (isAuth || token) {
				const token = getToken()
				if (token) {
					headers.Authorization = `Bearer ${token}`
					headers.AppHost = urls.hostname
				}
			} else {
				headers.AppHost = urls.hostname
			}

			if (params instanceof FormData) {
				headers['Content-Type'] = 'multipart/form-data'
			}

			return axiosApiInstance.post(url, params, { headers: headers, onUploadProgress: isAdaptive }).then((success: any) => {
				return resolve(success)
			}).catch((error: any) => {
				apiCatch(error)
				return reject(error.response)
			})
		})
	}

	static PUT(url: string, params: any, isAuth: boolean = false, isAdaptive: any = (e: any) => { }) {
		return new Promise((resolve, reject) => {
			const urls = new URL(window?.location?.href)
			let headers: any = { 'Content-Type': 'application/json' }
			if (isAuth || isAdaptive) {
				const token = getToken()
				if (token) {
					headers.Authorization = `Bearer ${token}`
					headers.AppHost = urls.hostname
				}
			} else {
				headers.AppHost = urls.hostname
			}
			return axiosApiInstance.put(url, params, { headers: headers, onUploadProgress: isAdaptive }).then((success: any) => {
				return resolve(success)
			}).catch((error: any) => {
				apiCatch(error)
				return reject(error.response)
			})
		})
	}

	static DELETE(url: string, params: any, isAuth: boolean = false, isAdaptive: any = (e: any) => { }) {
		return new Promise((resolve, reject) => {
			const urls = new URL(window?.location?.href)
			let headers: any = { 'Content-Type': 'application/json' }
			const token = getToken()
			if (isAuth || token) {
				if (token) {
					headers.Authorization = `Bearer ${token}`
					headers.AppHost = urls.hostname
				}
			} else {
				headers.AppHost = urls.hostname
			}

			return axiosApiInstance.delete(url, { headers: headers, onUploadProgress: isAdaptive, data: params }).then((success: any) => {
				return resolve(success)
			}).catch((error: any) => {
				apiCatch(error)
				return reject(error.response)
			})
			/* return axiosApiInstance({ method: 'DELETE', url, headers, params, }).then(success => {
				return resolve(success)
			}).catch(error => {
				apiCatch(error)
				return reject(error.response)
			}) */
		})
	}
}
